var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector"},_vm._l((_vm.selectors),function(item,index){
var _obj;
return _c('div',{key:index,class:( _obj = {'selected': _vm.selected == index}, _obj['selected' + index] = _vm.selected == index, _obj ),staticStyle:{"width":"50%","text-align":"center"},on:{"click":function($event){return _vm.handleSelector(index)}}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569a7318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fixed/selector.vue
// module id = null
// module chunks = 